// extracted by mini-css-extract-plugin
export var boxItems = "_ad-1";
export var boxItemsLg = "_ad-2";
export var button = "_ad-7";
export var buttonHoverless = "_ad-9";
export var buttonLg = "_ad-8";
export var filterGroupBox = "_ad-0";
export var icon = "_ad-3";
export var iconSecondary = "_ad-6";
export var iconWrapper = "_ad-4";
export var iconWrapperLg = "_ad-5";
export var truncatedLabel = "_ad-a";